module.exports = __webpack_public_path__ + "static/RajarshiDe-8ff817a6d3ed49551630c3426e7a37c4.jpg";